export const QUICK_XP = [50, 100, 250, 500];

// Largest amount the field takes; the server refuses anything past a billion.
export const MAX_XP_INPUT = 999_999;

export function parseAmount(text: string): number {
	return Math.min(Number.parseInt(text.replace(/\D/g, ""), 10) || 0, MAX_XP_INPUT);
}

// What the table's XP become for the character: the race's percentage on top, dropped to a whole number.
export function earned(amount: number, bonusPercent: number | null): number {
	return bonusPercent ? Math.trunc((amount * (100 + bonusPercent)) / 100) : amount;
}

export const xpTotal = (points: number, delta: number) => Math.max(0, points + delta);

// The next level's line is reached; a character with no class table has none.
export const reachesLevel = (total: number, nextPoints: number | null, atMax: boolean) => !atMax && nextPoints != null && total >= nextPoints;
